/** @jsx jsx */
import { jsx } from '@emotion/core'
import { OrigemDadoEnum } from 'graphql/types.generated'
import { HistoricoDwPanelProps, IdadeOrigemAtendimento } from 'view/atendimentos/detail/historico/model/model-historico'
import { IS_TIPO_ATIVIDADE_REUNIAO, tipoAtividadeByIdRecord } from 'view/atividade-coletiva/model-atividadeColetiva'

import HistoricoNoDetailAvailable from '../HistoricoNoDetailAvailable'
import HistoricoAtividadeColetivaPecPanelReuniao from './reuniao/HistoricoAtividadeColetivaPecPanelReuniao'
import HistoricoAtividadeColetivaDwPanelSaude from './saude/HistoricoAtividadeColetivaDwPanelSaude'
import HistoricoAtividadeColetivaPecPanelSaude from './saude/HistoricoAtividadeColetivaPecPanelSaude'

interface HistoricoAtividadeColetivaPanelProps extends HistoricoDwPanelProps {
  idAtividadeColetiva?: ID
  uuidRegistro: ID
  idadeOrigemAtendimento: IdadeOrigemAtendimento
  cpfOuCnsCidadao: string
  historicoOrigemAtendimento: OrigemDadoEnum
  coSubtipoAtendimento: number
  cidadaoId: ID
}

export default function HistoricoAtividadeColetivaPanel({
  idAtividadeColetiva,
  uuidRegistro,
  idadeOrigemAtendimento,
  cpfOuCnsCidadao,
  historicoOrigemAtendimento,
  coSubtipoAtendimento,
  cidadaoId,
}: HistoricoAtividadeColetivaPanelProps) {
  const isFonteDadosPec = historicoOrigemAtendimento === OrigemDadoEnum.PEC

  if (isTipoAtividadeReuniao[coSubtipoAtendimento]) {
    return isFonteDadosPec ? (
      <HistoricoAtividadeColetivaPecPanelReuniao
        idAtividadeColetiva={idAtividadeColetiva}
        idadeOrigemAtendimento={idadeOrigemAtendimento}
        cidadaoId={cidadaoId}
      />
    ) : (
      <HistoricoNoDetailAvailable />
    )
  } else {
    return isFonteDadosPec ? (
      <HistoricoAtividadeColetivaPecPanelSaude
        idAtividadeColetiva={idAtividadeColetiva}
        idadeOrigemAtendimento={idadeOrigemAtendimento}
        cidadaoId={cidadaoId}
      />
    ) : (
      <HistoricoAtividadeColetivaDwPanelSaude
        uuidRegistro={uuidRegistro}
        idadeOrigemAtendimento={idadeOrigemAtendimento}
        cpfOuCnsCidadao={cpfOuCnsCidadao}
      />
    )
  }
}

const isTipoAtividadeReuniao: Record<number, boolean> = Object.fromEntries(
  Object.entries(tipoAtividadeByIdRecord).map(([id, tipo]) => [Number(id), IS_TIPO_ATIVIDADE_REUNIAO[tipo]])
)
